import axios from '@axios'

// todo: fix it!
const widgetApiUrl = axios.defaults.baseURL.replace('api', 'widget')

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getEvents(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${widgetApiUrl}/${id}/data`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
